import { createContext, useContext } from 'react';

/**
 * "Este controle está sendo desenhado SOBRE a faixa laranja da marca" (at-66).
 *
 * 🔴 **Existe porque o `PageHeader` renderiza a MESMA `acaoDireita` em duas faixas de fundos
 * opostos**: a laranja do mobile e a branca do desktop. Um botão desenhado para uma fica errado na
 * outra — e o resultado, visto por Victor em 10/09/2026, era *"um negócio branco no meio do topbar
 * laranja, completamente destoado"*: o `Botao secundario` (branco sólido, borda cinza, sombra) é
 * feito para painel claro, e sobre o laranja virava um bloco gritante ao lado dos controles
 * translúcidos de menu e voltar.
 *
 * 📌 **O protótipo (`inspo/`) já resolvia isso, e é de lá que vem a aparência**: na faixa laranja a
 * ação é `bg-white/20` com texto branco e compacta (`px-3 py-2 text-xs`), da mesma família do
 * hambúrguer e do voltar (`bg-white/15`), só um pouco mais forte por ser ação; o laranja sólido fica
 * na faixa branca. Nós tínhamos portado só a versão do desktop.
 *
 * ⚠️ **Por contexto, e não por prop**, porque quem sabe em qual faixa o controle está é o
 * `PageHeader` — a tela passa **um** nó e ele é renderizado duas vezes. Com prop, cada tela teria de
 * declarar duas versões da mesma ação, e toda tela nova repetiria a decisão (e o erro).
 *
 * ⚠️ **Fora do `PageHeader` o valor é `false`**, então nada muda em nenhum outro lugar do app: o
 * comportamento novo só existe dentro do Provider.
 *
 * 🔴 Mora num módulo próprio para não criar ciclo: `Botao` (primitivo) consome o hook e `PageHeader`
 * (composição) fornece o Provider — os dois dependem daqui, e este arquivo não depende de ninguém.
 */
export const ContextoFaixaDaMarca = createContext(false);

/** `true` quando o controle está dentro da faixa laranja do cabeçalho. */
export const useEstaSobreAMarca = (): boolean => useContext(ContextoFaixaDaMarca);
